import {throwError as observableThrowError, Observable, BehaviorSubject} from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {AppSettings} from '../app.settings';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../global.service';
import {FacebookService, InitParams, UIParams, UIResponse} from 'ngx-facebook';
import {NotificationsService} from 'angular2-notifications';

@Injectable()
export class EventsService {
  template: any;
  Event: BehaviorSubject<any> = new BehaviorSubject<any>('');
  loading: boolean = false;
  load: boolean = false;
  loadTournaments: boolean = false;
  qualified_Players: Array<any> = [];
  iframeBracket: Array<any> = [];
  insomniaGame: any = '';
  participants_count: any = '';
  cfcLeaderBoard: Array<any> = [];
  cfcLeaderBoardStats: Array<any> = [];
  cfcAllStats: any;
  cfcLoadStats: boolean = true;
  eventTournaments: BehaviorSubject<any> = new BehaviorSubject<any>('');
  loadEventTournaments: boolean = false;
  _eventGames: BehaviorSubject<any> = new BehaviorSubject<any>('');
  Games = [];
  constructor(private notify: NotificationsService, private globalService: GlobalService, private fb: FacebookService, private http: HttpClient) {
    if (this.globalService.isBrwoser) {
      let fbParams: InitParams = {
        appId: '1692568150989522',
        xfbml: true,
        version: 'v3.3'
      };
      this.fb.init(fbParams);
    }
  }

  set eventGames(games: any) {
    this._eventGames.next(games);
  }

  get eventGames() {
    return this._eventGames;
  }

  shareEvent() {
    console.log('sharing...');
    const options: UIParams = {
      method: 'share',
      href: 'https://events.gbarena.com/' + this.Event.value.slug,
      hashtag: '#GBarena#events#' + this.Event.value.name,
      quote: this.Event.value.name,
      description: this.Event.value.description,
      name: this.Event.value.name,
    };

    this.fb.ui(options)
      .then((res: UIResponse) => {
        console.log(res);
        this.notify.success('Success', 'Tournament shared successfully');
      })
      .catch(error => {
        this.notify.error('Error', 'Tournament could not  be shared');
      });
  }


  getEvent(EventCode): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${EventCode}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response.data;
      }),
      catchError((err) => {
        return observableThrowError(err);
      }));

  }

  getEventTournaments(EventCode, page?, game_code?): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${EventCode}/tournaments${page ? ('?page=' + page) : ''}${game_code ? ('&game=' + game_code) : ''}`,
      AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }),
      catchError((err) => {
        return observableThrowError(err);
      }));
  }

  getEventPlayables(EventCode, page = 1, playables_type = 'all', per_page = 8): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${EventCode}/playables?page=${page}&playables_type=${playables_type}&per_page=${per_page}`,
      AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }),
      catchError((err) => {
        return observableThrowError(err);
      }));
  }
  getWinnerTournament(EventCode,participants_type){
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${EventCode}/winners${participants_type ? ('?participants_type=' + participants_type) : ''}`,
      AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }),
      catchError((err) => {
        return observableThrowError(err);
      }));
  }

  getEventBracket(EventCode): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/tournaments/${EventCode}/returnTree/1`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }),
      catchError((err) => {
        return observableThrowError(err);
      }),);
  }


  ShowQualifiedPlayers(slug) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${slug}/final`, AppSettings.getRequestOptions()).pipe(
      map((response: any) => {
        return response.data;
      }), catchError((err) => {
        return observableThrowError(err);
      }));
  }

  getParticipants(TournamentCode: string, page, name?, filter?: number, sort?, sort_type?): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/tournaments/${TournamentCode}/returnParticipants/confirmed?page=${page}${name ? `&name=${name}` : ``}${filter == 1 || filter == 0 ? `&complete=${filter}` : ``}${sort ? `&sortBy=${sort}` : ``}${sort_type ? `&sortMethod=${sort_type}` : ``}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return {participants: response.data};
      }));
  }
  getGulfWinners(): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/tournaments/zfg7538G1OIl/returnParticipants/winners`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return {participants: response.data};
      }));
  }

  getLeaderBoard(day) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/cfc/leaderboard?day=${day}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response.data;
      }));
  }

  getCFCStats(day) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/cfc/stats?day=${day}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }));
  }

  getEventLeaderBoard(event, board) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/events/${event}/leaderboards/${board}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return response;
      }));
  }

  // return tournament tree by code
  getTree(TournamentCode: string, stage: number) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/tournaments/${TournamentCode}/returnTree/${stage}`, AppSettings.getRequestOptions()).pipe(map(
      (response: any) => {
        return {tournamentTree: response};
      }
    ));
  }
}
